import $ from 'jquery';
import 'bootstrap';
import axios from 'axios';

function changeBrokerStatus (id, status) {
    axios.post('/broker/status/broker', {
        id,
        status,
    }).then(function (resp) {
        if (resp.data.status) {
            let element = document.getElementById('all-brokers')
            if (element) {
                element.innerHTML = resp.data.html
            }
        }
    })
}
$(document).ready(function() {
    $('#referral-code').tooltip({
        trigger: 'click',
        placement: 'bottom'
    });
});
function user_agreement () {
    $('#user-agreement').modal('show');
}
function submitUserAgreement () {
    var name=document.getElementById('partner_name').value;
    let error_title_element = document.getElementById('name_error')
    if(name==="") {
        name_error.innerHTML = '*Signature Is Required'
    } else {
        $('#user-agreement').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        document.getElementById("partnername").value=name;
        document.getElementById("terms").checked = true;
    }
}
function setTooltip (message) {
    $('#referral-code').tooltip('hide')
        .attr('data-original-title', message)
        .tooltip('show');
}

function hideTooltip () {
    setTimeout(function() {
        $('#referral-code').tooltip('hide');
    }, 1000);
}

function copyReferralCode (text) {
    text = text.toString()
    var input = document.createElement('input');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand('copy');
    document.body.removeChild(input);
    setTooltip('Copied to Clipboard')
    hideTooltip()
    return result;
}

function deleteBroker () {
    let id = document.getElementById('deleted-broker-id').value
    $("#delete-broker").modal('hide')
    axios.post('/broker/delete/broker', {
        id
    }).then(function (resp) {
        if (resp.data.status) {
            window.location.reload()
        }
    })
}

function deleteBrokerConfirm (id) {
    document.getElementById('deleted-broker-id').value = id
    $("#delete-broker").modal('show')
}

function client_coi (user_id,property_id,entity_type,user) {
   if(user == "broker")
   {
      url='/broker/view_coi'
   }
   else
   {
       url='/broker/employee/view_coi'
   }
   

  axios.get(url, {
    params: {

    property_id: property_id,
    user_id: user_id,
    entity_type:entity_type
    }
    }).then(function (resp) {
      
    resp=resp.data;
        
    if(resp != "")
    {
     
    if(resp.field_additional_remarks !=null )
    {
        
       document.getElementById("edit-field-additional-remarks-0-value").value = resp.field_additional_remarks;
    }
    if(resp.field_al_aggregate !=null)
    {
        
       document.getElementById("edit-field-al-aggregate-0-value").value = resp.field_al_aggregate;

    }
    if(resp.field_al_any_auto == 1)
    {
      
        document.getElementById("edit-field-al-any-auto-value").checked = true;
    }
    if(resp.field_al_bodily_injury_pa != null)
    {
        
       document.getElementById("edit-field-al-bodily-injury-pa-0-value").value = resp.field_al_bodily_injury_pa;

    } 
    if(resp.field_al_bodily_injury_pp != null)
    {
       document.getElementById("edit-field-al-bodily-injury-pp-0-value").value = resp.field_al_bodily_injury_pp;

    }
    if(resp.field_al_claims_made == 1)
    {
       document.getElementById("edit-field-al-claims-made-value").checked = true;
    }
    if(resp.field_al_combined_single_limit != null)
    {
        document.getElementById("edit-field-al-combined-single-limit-0-value").value = resp.field_al_combined_single_limit;

    }
    if(resp.field_al_each_occurrence != null)
    {
    document.getElementById("edit-field-al-each-occurrence-0-value").value = resp.field_al_each_occurrence;
    }
    if(resp.field_al_excess_liab == 1)
    {
        document.getElementById("edit-field-al-excess-liab-value").checked = true;

    }
    if(resp.field_al_hired_autos_only == 1)
    {
        document.getElementById("edit-field-al-hired-autos-only-value").checked = true;
     }
     if(resp.field_al_non_owned_autos_only == 1)
     {
        document.getElementById("edit-field-al-non-owned-autos-only-value").checked = true;
     }
     if(resp.field_al_occur == 1)
     {
        document.getElementById("edit-field-al-occur-value").checked = true;
     }
     
     if(resp.field_al_owned_autos_only == 1)
     {
        document.getElementById("edit-field-al-owned-autos-only-value").checked = true;
     }
     if(resp.field_al_property_damage_pa != null)
     {
    document.getElementById("edit-field-al-property-damage-pa-0-value").value = resp.field_al_property_damage_pa;

     }
     if(resp.field_al_scheduled_autos == 1)
     {
        document.getElementById("edit-field-al-scheduled-autos-value").checked = true;

     }
     if(resp.field_al_umbrella_liab == 1)
     {
        document.getElementById("edit-field-al-umbrella-liab-value").checked = true;
        }
        if(resp.field_certificate_holder != null)
        {
            document.getElementById("edit-field-certificate-holder-0-value").value = resp.field_certificate_holder;
        }
        
    if(resp.field_cgl_claims_made == 1)
    {
        document.getElementById("edit-field-cgl-claims-made-value").checked = true;
    }  
    if(resp.field_cgl_damage_to_rented != null)
    {
        document.getElementById("field_cgl_damage_to_rented").value = resp.field_cgl_damage_to_rented;

    }

    if(resp.field_cgl_each_occurrence != null)
    {
        document.getElementById("edit-field-cgl-each-occurrence-0-value").value = resp.field_cgl_each_occurrence;

    }

    if(resp.field_cgl_general_aggregate != null)
    {
        document.getElementById("edit-field-cgl-general-aggregate-0-value").value = resp.field_cgl_general_aggregate;

    }
    if(resp.field_cgl_loc == 1)
    {
        document.getElementById("edit-field-cgl-loc-value").checked = true;
    } 
    if(resp.field_cgl_med_exp != null)
    {
        document.getElementById("edit-field-cgl-med-exp-0-value").value = resp.field_cgl_med_exp;

    }
    if(resp.field_cgl_occur == 1)
    {
        document.getElementById("edit-field-cgl-occur-value").checked = true;
    } 
    if(resp.field_cgl_other==1)
    {
        document.getElementById("edit-field-cgl-other-value").checked = true;

    }
    if(resp.field_cgl_personal_adv_injury != null)
    {
        document.getElementById("edit-field-cgl-personal-adv-injury-0-value").value = resp.field_cgl_personal_adv_injury;
    }
    if(resp.field_cgl_policy==1)
    {
        document.getElementById("edit-field-cgl-policy-value").checked = true;

    }
    if(resp.field_cgl_products_comp_op_agg != null)
    {
        document.getElementById("edit-field-cgl-products-comp-op-agg-0-value").value = resp.field_cgl_products_comp_op_agg;
    }
    if(resp.field_cgl_project==1)
    {
        document.getElementById("edit-field-cgl-project-value").checked = true;
     }
     if(resp.field_description_of_operations != null)
     {
        document.getElementById("edit-field-description-of-operations-0-value").value = resp.field_description_of_operations;

     }
     if(resp.field_waiver_of_subrogation != null)
     {
        document.getElementById("edit-field-waiver-of-subrogation-0-value").value = resp.field_waiver_of_subrogation;

     }
     if(resp.field_wc_desease_ea_employee != null)
     {
        document.getElementById("edit-field-wc-desease-ea-employee-0-value").value = resp.field_wc_desease_ea_employee;

     }
     if(resp.field_wc_desease_policy_limit !=null)
     {
        document.getElementById("edit-field-wc-desease-policy-limit-0-value").value = resp.field_wc_desease_policy_limit;
    }
    if(resp.field_wc_each_accident != null)
    {
        document.getElementById("edit-field-wc-each-accident-0-value").value = resp.field_wc_each_accident;

    }
    if(resp.field_wc_other==1)
    {
        document.getElementById("edit-field-wc-other-value").checked = true;
     }

     if(resp.field_wc_per_statute==1)
    {
        document.getElementById("edit-field-wc-per-statute-value").checked = true;
     }
     

     $('#view_coi').on('hidden.bs.modal', function (e) {
        $(this)
          .find("input,textarea,select")
             .val('')
             .end()
          .find("input[type=checkbox], input[type=radio]")
             .prop("checked", "")
             .end();
      })
    }
     


    


    })
}
function submitActiveBrokers() {
    var myCheckboxes = new Array();
    $("input:checked").each(function() {
       myCheckboxes.push($(this).val());
    });
    axios.post('broker/confirm/active', {
        broker:myCheckboxes
    }).then(function (resp) {
        if(resp.data==false)
        {
            $("#confirm-brokers").modal('hide')
            $('#stripe_connect').modal('show');
        }
        else{
            window.location.href = "/broker";
        }
    })
   
}

// NOTE: this script block fixes 
// data-dismiss issue where modals' 
// cancel buttons don't work.
document.addEventListener('DOMContentLoaded', function () {
    // Function to hide modals manually
    function hideModal(modalId) {
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
            $(modalElement).modal('hide');
            console.log(`Modal ${modalId} hidden`);
        } else {
            console.error(`Modal ${modalId} not found`);
        }
    }

    // Attach event listeners to buttons with data-dismiss="modal"
    document.querySelectorAll('[data-dismiss="modal"]').forEach(button => {
        button.addEventListener('click', function() {
            // Find the parent modal
            const parentModal = this.closest('.modal');
            if (parentModal) {
                const modalId = parentModal.id;
                hideModal(modalId);
            } else {
                console.error('Parent modal not found');
            }
        });
    });
});

// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const brokerBrokersModule = {
    submitUserAgreement,
    deleteBroker,
    deleteBrokerConfirm,
    changeBrokerStatus,
    copyReferralCode,
    submitActiveBrokers,
}
